import {AppView} from '../view/app_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI} from '../thunk/table_tunc';

interface OwnProps {
    id:string
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
    }
}


const AppContainer=connect(mapStateToProps, bindDispatchToActions)(AppView);
export default AppContainer;